import { SelectWithGroups } from '../Common';

const SelectWrapper = ({ ...objProps }) => {
  return <SelectWithGroups {...objProps.field} {...objProps} />;
};

export default SelectWrapper;
